import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { formatErr } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  async function submit(e) {
    e.preventDefault(); setBusy(true);
    try {
      const u = await register({ ...form, role: "client" });
      toast.success(`Account created, ${u.name}`);
      nav("/client-portal");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Failed");
    } finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen grid place-items-center p-6 grain">
      <Card className="w-full max-w-md bg-[hsl(224_45%_9%)] border-border p-8 relative z-10">
        <h2 className="font-display text-3xl font-bold mb-1">Create client account</h2>
        <p className="text-sm text-muted-foreground mb-6">Book, track & join the lottery.</p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label className="text-xs uppercase tracking-wider text-muted-foreground">Name</Label>
            <Input required value={form.name} onChange={set("name")} data-testid="reg-name" className="mt-1.5 h-11 bg-[hsl(224_40%_12%)]" /></div>
          <div><Label className="text-xs uppercase tracking-wider text-muted-foreground">Email</Label>
            <Input required type="email" value={form.email} onChange={set("email")} data-testid="reg-email" className="mt-1.5 h-11 bg-[hsl(224_40%_12%)]" /></div>
          <div><Label className="text-xs uppercase tracking-wider text-muted-foreground">Phone</Label>
            <Input value={form.phone} onChange={set("phone")} data-testid="reg-phone" className="mt-1.5 h-11 bg-[hsl(224_40%_12%)]" /></div>
          <div><Label className="text-xs uppercase tracking-wider text-muted-foreground">Password</Label>
            <Input required type="password" value={form.password} onChange={set("password")} data-testid="reg-password" className="mt-1.5 h-11 bg-[hsl(224_40%_12%)]" /></div>
          <Button disabled={busy} data-testid="reg-submit" className="w-full h-11 bg-amber-500 text-[hsl(224_60%_6%)] hover:bg-amber-400 font-semibold">
            {busy ? "Creating…" : "Create account"}
          </Button>
        </form>
        <div className="mt-5 text-xs text-center text-muted-foreground">
          Already registered? <Link to="/login" className="text-amber-400 hover:underline">Sign in</Link>
        </div>
      </Card>
    </div>
  );
}
